import styled from 'styled-components';

// Container principal que funciona como overlay
export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: var(--surface-overlay);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 20px;
  box-sizing: border-box;
`;


export const AssetCard = styled.div`
  background: var(--app-bg-gradient);
  border-radius: 12px;
  padding: 30px;
  width: 90%;
  max-width: 800px;
  max-height: 80vh;
  overflow-y: auto;
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px var(--accent-soft);
  position: relative;
  
  /* Scroll personalizado */
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: var(--input-bg);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: var(--accent-secondary);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: var(--brand-blue);
  }
`;

export const BtnClose = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  color: var(--accent-secondary);
  cursor: pointer;
  padding: 5px;
  transition: color 0.3s ease;
  z-index: 10;

  &:hover {
    color: var(--brand-blue);
  }
`;

export const Title = styled.h3`
  font-size: 2rem;
  font-weight: 800;
  color: var(--accent-secondary);
  text-shadow: 0 4px 20px var(--accent-secondary-soft);
  margin: 20px 0;
  letter-spacing: -0.02em;
  text-align: center;
  padding-right: 40px; /* Espaço para o botão de fechar */

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }

  @media (max-width: 480px) {
    font-size: 1.2rem;
  }
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 25px;
  padding: 15px;
  border-radius: 8px;
  gap: 10px;
`;

export const BtnPagination = styled.button`
  background: ${props =>
    props.disabled ? 'var(--text-heading)' :
      props.active ? 'var(--accent-secondary)' : 'var(--brand-blue)'};
  border: none;
  border-radius: 6px;
  color: ${props =>
    props.disabled ? 'var(--text-muted)' :
      props.active ? 'var(--brand-navy)' : 'var(--accent-secondary)'};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  padding: 8px 16px;
  font-weight: ${props => props.active ? 'bold' : '600'};
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background: var(--accent-secondary);
    color: var(--brand-navy);
    transform: translateY(-2px);
  }
`;

export const BtnNav = styled.button`
  background: transparent;
  border: none;
  border-radius: 50%;
  color: var(--accent-secondary);
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-size: 1.2rem;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  opacity: ${props => props.disabled ? 0.5 : 1};

  &:hover:not(:disabled) {
    transform: scale(1.1);
  }
`;

export const AssetItem = styled.div`
  background: var(--surface-glass);
  border-radius: 8px;
  padding: 15px;
  margin: 10px 0;
  backdrop-filter: blur(5px);
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
`;

export const AssettField = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  margin: 8px 0;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  gap: 5px;
`;

export const TitleField = styled.span`
  color: var(--accent-secondary);
  font-size: 1rem;
  line-height: 1.2;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  white-space: nowrap;
`;

export const ValueField = styled.span`
  color: var(--accent-secondary-soft);
  font-size: 0.9rem;
  line-height: 1.4;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  flex: 1;
`;

export const EmptyMessage = styled.p`
  color: var(--accent-secondary);
  text-align: center;
  font-size: 1.1rem;
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  
  i {
    font-size: 1.2rem;
  }
`;

// Container para os filtros de data
export const DateFilterContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 25px;
  justify-content: center;
  flex-wrap: wrap;
  align-items: flex-start;

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
`;

// Container individual para cada input de data com label
export const DateInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

// Estilo para os inputs de data
export const DateInput = styled.input`
  background: var(--input-bg);
  border: 2px solid var(--accent-secondary-soft);
  border-radius: 8px;
  padding: 12px 16px;
  color: var(--accent-secondary-soft);
  font-size: 1rem;
  font-family: inherit;
  outline: none;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
  min-width: 180px;
  margin-top: 8px;

  &::placeholder {
    color: var(--text-muted);
  }

  &:focus {
    border-color: var(--accent-secondary);
    box-shadow: 0 0 0 3px var(--border-subtle);
    background: var(--input-bg);
  }

  &:hover {
    border-color: var(--border-strong);
  }

  /* Estilização do calendário nativo */
  &::-webkit-calendar-picker-indicator {
    filter: invert(0.8) sepia(1) saturate(5) hue-rotate(70deg);
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    background: var(--accent-secondary-soft);
  }

  &::-webkit-datetime-edit-fields-wrapper {
    color: var(--accent-secondary-soft);
  }

  &::-webkit-datetime-edit-text {
    color: var(--accent-secondary);
    padding: 0 2px;
  }

  &::-webkit-datetime-edit-month-field,
  &::-webkit-datetime-edit-day-field,
  &::-webkit-datetime-edit-year-field {
    color: var(--accent-secondary-soft);
  }

  @media (max-width: 480px) {
    width: 100%;
    max-width: 250px;
  }
`;

// Label para os inputs de data
export const DateLabel = styled.label`
  color: var(--accent-secondary);
  font-size: 0.9rem;
  font-weight: 600;
  display: block;
  text-align: center;
  margin-bottom: 5px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;